module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body timeline_box",
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "time"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTotalizador || _vm.mostrarOpcoes),
      expression: "mostrarTotalizador || mostrarOpcoes"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarOpcoes),
      expression: "mostrarOpcoes"
    }],
    staticClass: "quadro_opcoes"
  }, [_c('span', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Opções do timeline:")]), _vm._v(" "), _c('div', {
    staticClass: "visao"
  }, [_vm._v("Visão "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.posicao),
      expression: "posicao"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.posicao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 'absoluto'
    }
  }, [_vm._v("Distâncias representam dias")]), _c('option', {
    domProps: {
      "value": 'relativo'
    }
  }, [_vm._v("Cada marcador virá atras do outro")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posicao === 'absoluto'),
      expression: "posicao === 'absoluto'"
    }],
    staticClass: "zoom"
  }, [_vm._v("Zoom "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoom),
      expression: "zoom"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm._.range([_vm.start = 1], 6.5, [_vm.step = .5])), function(z) {
    return _c('option', [_vm._v(_vm._s(z))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posicao === 'absoluto'),
      expression: "posicao === 'absoluto'"
    }],
    staticClass: "mostrar_escala"
  }, [_vm._v("Mostrar escala "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrarEscala),
      expression: "mostrarEscala"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mostrarEscala = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "linha_situacoes"
  }, [_vm._v("Mostrar situação do projeto na linha "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrarSituacoesHistoricas),
      expression: "mostrarSituacoesHistoricas"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mostrarSituacoesHistoricas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTotalizador),
      expression: "mostrarTotalizador"
    }],
    staticClass: "quadro_totalizador"
  }, [_c('div', {
    staticClass: "grupo"
  }, [_c('div', {
    staticClass: "cabecalho_grupo"
  }, [_c('div', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Ocorrências")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['INFORMACAO', 'OCORRENCIA_IMPEDITIVA'])) ? _c('div', [_c('div', [_vm._v("Em Ser")]), _vm._v(" "), _c('div', [_vm._v("Baixadas")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['INFORMACAO', 'OCORRENCIA_IMPEDITIVA'], o.codigo); })), function(item) {
    return _c('div', {
      staticClass: "coluna_grupo"
    }, [_c('div', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      attrs: {
        "title": '<h5>' + item.descricao + '</h5>'
      }
    }, [_c('i', {
      class: 'marcador ' + _vm.icone(item.codigo),
      on: {
        "click": function($event) {
          return _vm.filtrarTimeline(item.codigo)
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: item.ocorrencia_em_ser > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.ocorrencia_em_ser))]), _vm._v(" "), _c('div', {
      class: item.ocorrencia_baixada > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.ocorrencia_baixada))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "grupo"
  }, [_c('div', {
    staticClass: "cabecalho_grupo"
  }, [_c('div', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Demandas")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['DEMANDA_FBB', 'DEMANDA_PARCEIRO'])) ? _c('div', [_c('div', [_vm._v("Em Condução")]), _vm._v(" "), _c('div', [_vm._v("Concluídas")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['DEMANDA_FBB', 'DEMANDA_PARCEIRO'], o.codigo); })), function(item) {
    return _c('div', {
      staticClass: "coluna_grupo"
    }, [_c('div', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      attrs: {
        "title": '<h5>' + item.descricao + '</h5>'
      }
    }, [_c('i', {
      class: 'marcador ' + _vm.icone(item.codigo),
      on: {
        "click": function($event) {
          return _vm.filtrarTimeline(item.codigo)
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: item.demanda_em_conducao > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.demanda_em_conducao))]), _vm._v(" "), _c('div', {
      class: item.demanda_concluida > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.demanda_concluida))])])])
  })], 2), _vm._v(" "), _c('div', {
    ref: "totalizador_contatos",
    staticClass: "grupo"
  }, [_c('div', {
    staticClass: "cabecalho_grupo"
  }, [_c('div', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_acompanhamento, ['CONTATO'])) ? _c('div', [_c('div', [_vm._v("Total realizado")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.totalizador.total_acompanhamento, function (o) { return _vm._.includes(['CONTATO'], o.codigo); })), function(item) {
    return _c('div', {
      staticClass: "coluna_grupo"
    }, [_c('div', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      attrs: {
        "title": '<h5>' + item.descricao + '</h5>'
      }
    }, [_c('i', {
      class: 'marcador ' + _vm.icone(item.codigo),
      on: {
        "click": function($event) {
          return _vm.filtrarTimeline(item.codigo)
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: item.contatos > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.contatos))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "grupo"
  }, [_c('div', {
    staticClass: "cabecalho_grupo"
  }, [_c('div', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Alterações em projetos")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_alteracoes, null)) ? _c('div', [_c('div', [_vm._v("Eficiência")]), _vm._v(" "), _c('div', [_vm._v("Externalidade")]), _vm._v(" "), _c('div', [_vm._v("FBB")]), _vm._v(" "), _c('div', [_vm._v("Falha planejamento")])]) : _c('div', [_c('div', [_vm._v("Não houve")])])]), _vm._v(" "), _vm._l((_vm.totalizador.total_alteracoes), function(item) {
    return _c('div', {
      staticClass: "coluna_grupo"
    }, [_c('div', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      attrs: {
        "title": '<h5>' + item.descricao + '</h5>'
      }
    }, [_c('i', {
      class: 'marcador ' + _vm.icone(item.codigo),
      on: {
        "click": function($event) {
          return _vm.filtrarTimeline(item.codigo)
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: item.eficiencia > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.eficiencia))]), _vm._v(" "), _c('div', {
      class: item.externalidade > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.externalidade))]), _vm._v(" "), _c('div', {
      class: item.fbb > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.fbb))]), _vm._v(" "), _c('div', {
      class: item.falha > 0 ? 'realce' : 'esmaecer'
    }, [_vm._v(_vm._s(item.falha))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "grupo"
  }, [_c('div', {
    staticClass: "cabecalho_grupo"
  }, [_c('div', {
    staticClass: "titulo_grupo"
  }, [_vm._v("Relatórios de Execução")]), _vm._v(" "), (_vm.haRegistros(this.totalizador.total_relatorios_execucao, null)) ? _c('div', [_c('div', [_vm._v("Entregue")]), _vm._v(" "), _c('div', [_vm._v("Pendente")])]) : _c('div', [_c('div', [_vm._v("Não há")])])]), _vm._v(" "), _vm._l((_vm.totalizador.total_relatorios_execucao), function(item) {
    return _c('div', {
      staticClass: "coluna_grupo"
    }, [_c('div', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      attrs: {
        "title": '<h5>' + item.descricao + '</h5>'
      }
    }, [_c('i', {
      class: 'marcador ' + _vm.icone(item.codigo),
      on: {
        "click": function($event) {
          return _vm.filtrarTimeline(item.codigo)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "realce"
    }, [_vm._v(_vm._s(item.entregue))]), _vm._v(" "), _c('div', {
      staticClass: "realce"
    }, [_vm._v(_vm._s(item.pendente))])])])
  })], 2)])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-isolate-scope novo_timeline"
  }, [_c('div', {
    ref: "timeline",
    staticClass: "linha_tempo"
  }, [_vm._l((_vm._.range([_vm.start = 0], _vm.qdtEventos + 30, [_vm.step = 30])), function(dias) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostrarEscala && _vm.posicao === 'absoluto'),
        expression: "mostrarEscala && posicao === 'absoluto'"
      }],
      staticClass: "marcacao_escala",
      style: ('margin-left: ' + ((dias * parseInt(_vm.zoom)) + 56) + 'px; width: ' + (_vm.zoom) + 'px;')
    }, [_c('span', {
      staticClass: "texto_vertical"
    }, [_vm._v(_vm._s(_vm.diasData(_vm.projeto.inicio, dias)))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "eventos",
    style: ('width: ' + ((_vm.posicao === 'absoluto') ? ((_vm.ultimaReferencia + 75) * _vm.zoom) : (_vm.eventos.length * 160)) + 'px')
  }, [_c('div', {
    staticClass: "linha",
    style: ('width: ' + ((_vm.posicao === 'absoluto') ? ((_vm.ultimaReferencia + 75) * _vm.zoom) : (_vm.eventos.length * 160) + 80) + 'px')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarSituacoesHistoricas),
      expression: "mostrarSituacoesHistoricas"
    }],
    staticClass: "situacao_projeto"
  }, [_vm._l((_vm.eventos), function(evento, eventoIndex) {
    return (_vm.posicao === 'absoluto') ? _c('div', {
      class: _vm.situacaoProjeto(evento.data),
      style: ('width: ' + (eventoIndex === _vm.eventos.length - 1 ? 75 : (eventoIndex > 0 ? (evento.referencia - _vm.eventos[eventoIndex - 1].referencia) * _vm.zoom : 0)) + 'px')
    }, [_vm._v(" ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.eventos), function(evento, eventoIndex) {
    return (_vm.posicao === 'relativo') ? _c('div', {
      class: _vm.situacaoProjeto(evento.data),
      staticStyle: {
        "width": "160px"
      }
    }, [_vm._v(" ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _vm._l((_vm.eventos), function(evento) {
    return _c('div', {
      class: 'evento posicao_' + _vm.posicao,
      attrs: {
        "id": evento.tag + '_' + evento.id
      }
    }, [_c('div', {
      ref: _vm._.startsWith(evento.tag, 'HOJE') ? 'HOJE' : evento.id,
      refInFor: true,
      style: (_vm.posicao === 'absoluto' ? 'margin-left: ' + (evento.referencia * _vm.zoom) + 'px' : '')
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          placement: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
      }],
      class: 'marcador' + (evento.id === _vm.temp ? ' evento_sinalizado' : ''),
      style: ('background:' + _vm.cor(evento.situacao) + '; cursor: ' + (evento.grupo === 'projeto' ? 'unset' : 'pointer')),
      attrs: {
        "title": '<h5>' + evento.descricao + '<br/>' + evento.info + '</h5>'
      },
      on: {
        "click": function($event) {
          return _vm.filtrarGrids(evento.grupo, evento.id)
        }
      }
    }, [_c('i', {
      class: _vm.icone(evento.tag),
      style: ('vertical-align: middle;text-align: center;')
    }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
      class: 'info_superior' + (_vm.data_vertical ? ' texto_vertical' : '')
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.posicao === 'absoluto' ? '' : evento.data, 'DD/MMM/YY')))]), _vm._v(" "), _c('div', {
      staticClass: "info_inferior",
      style: ('padding-top: ' + (_vm.data_vertical ? 70 : 20) + 'px')
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.posicao === 'absoluto' ? '' : evento.descricao)
      }
    })])])])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "botoes_timeline"
  }, [_c('div', {
    staticClass: "opcoes",
    on: {
      "click": function($event) {
        _vm.mostrarOpcoes = !_vm.mostrarOpcoes, _vm.mostrarTotalizador = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Opções\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        interactive: true,
        theme: 'light',
        trigger: 'click',
        position: 'top'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', trigger: 'click', position: 'top'}"
    }],
    staticClass: "legenda",
    attrs: {
      "title": '<table class=\'legenda_tabela\'>' +
        '<tr><td style=\'background:' + _vm.cor('FEITO') + '\'>&nbsp;</td><td>Datas de aprovação, início de execução, alterações no projeto, data do término da execução, data do encerramento; Relatório de execuação aprovado</td></tr>' +
        '<tr><td style=\'background:' + _vm.cor('CONCLUIDO') + '\'>&nbsp;</td><td>Registros de contato, demandas concluídas, informações, ocorrências baixadas</td></tr>' +
        '<tr><td style=\'background:' + _vm.cor('EM_CONDUCAO') + '\'>&nbsp;</td><td>Demandas FBB ou Parceiro com status “Em condução”; ocorrências impeditivas em ser; relatório de execução não disponível</td></tr>' +
        '<tr><td style=\'background:' + _vm.cor('NORMAL') + '\'>&nbsp;</td><td>Relatório de execução disponível</td></tr>' +
        '<tr><td style=\'font-size: xx-large; color:' + _vm.cor('FEITO') + '\'>_</td><td>Situação do projeto regular</td></tr>' +
        '<tr><td style=\'font-size: xx-large; color:' + _vm.cor('EM_CONDUCAO') + '\'>_</td><td>Situação não regular do projeto</td></tr>' +
        '</table>' + '<br>* Obs: Ao selecionar um registro de acompanhamento ou de alteração de projeto, a borda do evento na linha do tempo, ficará <span class=evento_sinalizado>assim</span>'
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Legenda\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "totalizador",
    on: {
      "click": function($event) {
        _vm.mostrarTotalizador = !_vm.mostrarTotalizador, _vm.mostrarOpcoes = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" Totais\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        placement: 'top',
        theme: 'light'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top', theme: 'light'}"
    }],
    staticClass: "hoje",
    attrs: {
      "title": '<h5>' + (_vm.projeto.turno === 'HOJE_DIA' ? 'Bom dia!' : 'Boa noite!') + '<br/>Duração do projeto de ' + _vm.projeto.periodos + ' meses<br/>' + ((_vm.projeto.hoje_dias / (_vm.projeto.periodos * 30)) <= 1 ? 'Já passou <b>' + parseInt(_vm.projeto.hoje_dias / (_vm.projeto.periodos * 30) * 100) + '%</b> desde seu início' : '') + '</h5>'
    },
    on: {
      "click": _vm.moverParaHoje
    }
  }, [_c('i', {
    class: 'fa ' + (_vm.icone(_vm.projeto.turno))
  }), _vm._v(" Hoje " + _vm._s(_vm.diasData(new Date(), 0)) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.eventos.length !== _vm.eventosBackup.length),
      expression: "eventos.length !== eventosBackup.length"
    }],
    staticClass: "reload",
    on: {
      "click": _vm.voltarBackupEventos
    }
  }, [_c('i', {
    class: 'fa fa-refresh'
  }), _vm._v(" Recarregar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6097d46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/Timeline.vue
// module id = 2086
// module chunks = 1